import { Controller } from "@hotwired/stimulus"

// This controller is used to open a modal to save selected companies to a new company list.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedCompanyIds: { type: Array, default: [] },
    }
  }

  show() {
    let url = new URL("/company-lists/new", window.location.origin)

    if (this.selectedCompanyIdsValue.length > 0) {
      this.selectedCompanyIdsValue.forEach(companyId => {
        url.searchParams.append("company_ids[]", companyId)
      })
    } else if (Object.entries(this.filtersValue).length > 0) {
      // If there are filters, we append them to the URL
      Object.entries(this.filtersValue).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(arrayValue => {
            url.searchParams.append(key + "[]", arrayValue)
          })
        } else {
          url.searchParams.append(key, value)
        }
      })
    } else {
      url.searchParams.append("company_list_id", "all")
    }

    Turbo.visit(url.toString(), { frame: "save_as_company_list" })
  }

  updateSelection(event) {
    this.selectedCompanyIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
  }
}
